import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider } from "react-router-dom"

import "@mantine/core/styles.css"

import { Loader } from "@mantine/core"
import React from "react"
import "./index.css"
import About from "./Pages/About/Page"
import { Branches } from "./Pages/Branches/Page"
import { Contact } from "./Pages/Contact/Page"
import { E404 } from "./Pages/Errors/404"
import { Home } from "./Pages/Home/Page"
import { Products } from "./Pages/Products/Page"
import { Root } from "./Root"

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Home />
      },
      {
        path: "/about-us",
        element: <About />
      },
      {
        path: "/products",
        element: <Products />
      },
      {
        path: "/branches",
        element: <Branches />
      },
      {
        path: "/contact",
        element: <Contact />
      }
    ],
    errorElement: <E404 />
  }
])

createRoot(document.getElementById("root")!).render(
  <React.Suspense fallback={<Loader size="lg" variant="dots" />}>
    <RouterProvider router={router} />
  </React.Suspense>
)
